import { createPkceClient } from '@dstbfs/auth-pkce'

/** App-wide PKCE client: issuer from VITE_DSTMAX_ISSUER (dev default), redirect back to this origin's /auth/callback. */
export const auth = createPkceClient({
  issuer: import.meta.env['VITE_DSTMAX_ISSUER'] ?? 'http://localhost:5100',
  clientId: 'dstbfs-web',
  redirectUri: `${window.location.origin}/auth/callback`,
  scopes: ["openid", "profile", "offline_access"],
  storageKey: 'dstbfs',
  storage: sessionStorage,
})
